import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ConfigService } from '@shared/services/config/config.service';

import { LocalStorageService } from '@shared/services/local-storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    @Inject(Router) private _router: Router,
    @Inject(LocalStorageService)
    @Inject(LocalStorageService) private _localStorageService: LocalStorageService,
    @Inject(ConfigService) private configService: ConfigService) {}

  canActivate(): boolean {
    const token = this._localStorageService.getBearerToken();
    const state = this._router.getCurrentNavigation().extras?.state;
    const isAuthorizing = (state?.authCode && state?.authState) || state?.bearerToken;

    if (token || isAuthorizing) {
      this.configService.initiateChatDesk()
      return true;
    }

    this._router.navigate(['/login']);
    return false;
  }
}
